import {connect} from "react-redux"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    const {isEnableCountrySelectorButton} = state.countrySelector
    const {xxlBreakpointEnabled} = state.settings

    return {
        templating: state.template,
        showCountrySelector: isEnableCountrySelectorButton,
        xxlBreakpointEnabled,
    }
}

export default connect(mapStateToProps)
